import { reduxKey } from './constants';
import { CommentBoxStoreSlice } from './types';

export const getEditorSlice = (state, editorId): CommentBoxStoreSlice =>
  (state[reduxKey] && state[reduxKey][editorId]) || {};

export const isBusy = (state, editorId) =>
  getEditorSlice(state, editorId)['isBusy'] ?? false;

export const getPublishResult = (state, editorId) =>
  getEditorSlice(state, editorId)['publishResult'];

export const isError = (state, editorId) =>
  getEditorSlice(state, editorId)['isError'];

export const getErrorMsg = (state, editorId) =>
  getEditorSlice(state, editorId)['errorMsg'];

export const getShouldResetEditor = (state, editorId): boolean | undefined =>
  getEditorSlice(state, editorId)['shouldResetEditor'];

export const getIsFocusRequested = (
  state,
  editorId: string,
  defaultValue: boolean = false
) => {
  const focus = getEditorSlice(state, editorId)['isFocusRequested'];
  if (focus === undefined) {
    return defaultValue;
  }

  return focus;
};
